import _ from 'lodash'

import default_cfg from './default.json'
import debugcfg from './debug.json'
import prodcfg from './production.json'

const cfg = process.env.NODE_ENV === 'production'? prodcfg : debugcfg

export default _.merge(default_cfg, cfg)
